import { Notification } from '../app/dashboard/interfaces/notifications.interfaces';
import React, { Fragment, useEffect } from 'react';
import { useToastNotifications } from '../hooks/useToastNotifications';
import Alert from '../components/alertComponent';
import { replaceTokensToDate } from '../utilities/sanitizer';
import { NOTIFICATIONS } from '../utilities/routes';
import ButtonComponent from '../components/button/buttonComponent';
import { CustomNotificationActions } from '../hooks/useHandleExtraActions';
import { ALERT_TYPE_BY_NOTIFICATION_TYPE } from '../const/notification';

interface ToastNotificationsProps {
  toastNotifications: Notification[];
  handleAction: (
    notificationId: string,
    route: string,
    customAction?: CustomNotificationActions,
    customActionParams?: Record<string, unknown>,
    isCloseButton?: boolean,
  ) => void;
}

export const ToastNotifications: React.FC<ToastNotificationsProps> = ({
  toastNotifications,
  handleAction,
}) => {
  const afterTimeoutCallback = (id: string) => {
    const selectedToast = toastNotifications.find(
      (notification) => notification.id === id,
    );
    handleAction(
      id,
      selectedToast?.action?.route ?? NOTIFICATIONS,
      selectedToast?.action?.customAction,
      selectedToast?.action?.customActionParams,
      true,
    );
  };

  const { toasts, showToast, onMouseEnter, onMouseLeave } =
    useToastNotifications(afterTimeoutCallback);

  useEffect(() => {
    toastNotifications.forEach((notification) => {
      showToast(notification);
    });
  }, [toastNotifications, showToast]);

  return (
    <div>
      {toasts.length > 0 &&
        toasts.map((notification) => {
          return (
            <div className="my-3 z-50" key={notification.id}>
              <Alert
                onMouseEnter={() => onMouseEnter(notification.id)}
                onMouseLeave={() => onMouseLeave(notification.id)}
                key={notification.id}
                testID={'alert-' + notification.activityType}
                type={
                  notification.type
                    ? ALERT_TYPE_BY_NOTIFICATION_TYPE[notification.type]
                    : 'positive'
                }
                text={`${replaceTokensToDate(
                  notification.title,
                  notification.constants,
                )} ${replaceTokensToDate(
                  notification.message,
                  notification.constants,
                )}`}
                actionLabel={notification.action?.actionName ?? ''}
                onActionClick={() =>
                  handleAction(
                    notification.id,
                    notification.action?.route ?? NOTIFICATIONS,
                    notification.action?.customAction,
                    notification.action?.customActionParams,
                  )
                }
                onClose={() =>
                  handleAction(
                    notification.id,
                    notification.action?.route ?? NOTIFICATIONS,
                    notification.action?.customAction,
                    notification.action?.customActionParams,
                    true,
                  )
                }
                isNotification
                hideCloseButton={true}
                enableAutoFittingOfExtraActions
                extraActions={notification.extraActions?.map((action, key) => (
                  <Fragment key={`${key}-${action.actionName}`}>
                    <ButtonComponent
                      type={action?.type ?? 'underline'}
                      iconPosition="right"
                      testID={'alert-button-' + action.actionName}
                      className="mt-5 desktop:mt-0"
                      onClick={() =>
                        handleAction(
                          notification.id,
                          action?.route ?? NOTIFICATIONS,
                          action?.customAction,
                          action?.customActionParams,
                        )
                      }
                    >
                      {action.actionName}
                    </ButtonComponent>
                  </Fragment>
                ))}
              />
            </div>
          );
        })}
    </div>
  );
};
